import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router";

import { Card, TabMenu } from "@digital-services/ui";
import { ITabMenuTab } from "@digital-services/ui/types";

import { useTabIndex } from "@hooks/useTabIndex";

const SettingsTabMenu: FC = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "settings" });

  const renderCardContent = (id: string) => {
    return (
      <Card className="max-w-md" data-testid={`${id}-tab-card`}>
        <Outlet />
      </Card>
    );
  };

  const tabs: ITabMenuTab[] = [
    {
      id: "account",
      label: t("account_tab.label"),
      content: renderCardContent("account")
    },
    {
      id: "language",
      label: t("language_tab.label"),
      content: renderCardContent("language")
    }
  ];

  const { currentTabIndex } = useTabIndex(tabs);
  const navigate = useNavigate();

  const handleChangeTab = (tabIndex: number) => {
    if (tabIndex === 0) {
      return navigate("");
    }

    navigate(tabs[tabIndex].id.toLowerCase());
  };

  return (
    <TabMenu value={currentTabIndex} onChange={handleChangeTab} tabs={tabs} />
  );
};

export default SettingsTabMenu;
